import React from "react";
import { Card } from "../atoms";
import styled from "styled-components";
import { theme } from "../theme/semanticTheme";

const Wrapper = styled(Card)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  min-height: 72px;
`;

const IconWrap = styled.div`
  width: 44px;
  height: 44px;
  border-radius: ${theme.borderRadius.lg};
  background: ${theme.colors.accentLight};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg,
  img {
    width: 24px;
    height: 24px;
  }
`;

const Content = styled.div`
  min-width: 0;
`;

const Label = styled.span`
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.textMuted};
  display: block;
  margin-bottom: 2px;
`;

const Value = styled.span`
  font-size: ${theme.typography.fontSize.lg};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.primary};
`;

/**
 * Molecule: StatCard – icon + label + value. Reusable for dashboard metrics.
 */
export default function StatCard({ icon, label, value }) {
  return (
    <Wrapper>
      <IconWrap>{icon}</IconWrap>
      <Content>
        <Label>{label}</Label>
        <Value>{value ?? "–"}</Value>
      </Content>
    </Wrapper>
  );
}
